// @copyright  2006-2022 West Indies Software Engineering Company Limited. All rights reserved.

export default [
    {
        path: '/:organisation/import-trial-balance',
        component: () =>
            import('@/pages/[organisation]/import-trial-balance.vue'),
        name: 'accounting.general-ledgers.import-trial-balance',
        meta: {
            guestRequired: false,
            loginRequired: true,
            permission: 'access.accounting.general-ledger.create-manual-journal-entry',
        },
    },
];
